
// export const myGetter = ( rol ) => {
//  return rol
// }

export const rolesList = state => state.roles
export const rolesSelectable = state => state.rolesSelectable
export const rolesPaginatedData = state => state.rolesPaginatedData
export const rol = state => state.rol
export const clientSelect = state => state.clientSelect
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData
export const isLoadingRolProducts = state => state.isLoadingRolProducts
export const clientProducts = state => state.clientProducts
